import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: '/admin/admin/log/page',
    method: 'get',
    params: query
  })
}

export function delObj (id) {
  return request({
    url: '/admin/admin/log/' + id,
    method: 'delete'
  })
}

export function fetchUserActionLogList(query) {
  return request({
      url: `/basic/admin/useractionlog/page` ,
      method: 'get',
      params: query
  })
}

export function fetchActionUserList() {
  return request({
      url: `/basic/admin/useractionlog/userIds` ,
      method: 'get'
  })
}